import types from '../types'

const initialState = {
  activeKey: 'assessment',
  nextClicked: false,
  showExitModal: false,
  exitModal: {
    title: '',
    content: '',
    kind: ''
  }
}

const headerReducer = (state = initialState, action) => {
  switch (action.type) {
  case types.SET_ACTIVE_HEADER_KEY:
    return {
      ...state,
      activeKey: action.payload
    }
  case types.SET_NEXT_CLICKED:
    return {
      ...state,
      nextClicked: action.payload
    }
  case types.SET_SHOW_EXIT_MODAL: {
    return {
      ...state,
      showExitModal: action.payload
    }
  }
  case types.SET_EXIT_MODAL: {
    return {
      ...state,
      exitModal: action.payload
    }
  }
  default:
    return state
  }
}

export default headerReducer
